import React from "react";
import MPaper from "@mui/material/Paper";

const Paper = (props) => {
  return <MPaper {...props} />;
};

export default Paper;
